import { connect } from 'react-redux';
import { fetchConsultantsList, setIsConsultantsListLoading } from '../../../actions/consultantActions';

// on importe le composant de présentation
import ConsultantsList from '../../../components/InfosPage/ConsultantsList';

// === mapStateToProps
// si on a besoin de lire des informations dans le state
const mapStateToProps = (state) => ({
  // nom de la prop à remplir: élément à récupérer dans le state
  crealisConsultantsArray: state.consultantReducer.crealisConsultantsArray,
  portsideConsultantsArray: state.consultantReducer.portsideConsultantsArray,
  hcsConsultantsArray: state.consultantReducer.hcsConsultantsArray,
});

// === mapDispatchToProps
// si on a besoin de dispatcher des actions vers le store (modifier le state)
const mapDispatchToProps = (dispatch) => ({
  // nom de la prop à remplir: fonction qui dispatch l'action
  setIsConsultantsListLoading: (newValue) => {
    dispatch(setIsConsultantsListLoading(newValue));
  },
  loadConsultantsList: (companyValue) => {
    dispatch(fetchConsultantsList(companyValue));
  },
});

// === création de l'assistant
export default connect(mapStateToProps, mapDispatchToProps)(ConsultantsList);